import { OptionStyles } from '../../../../styles/react-select/theme';

export const DEFAULT_MODEL = 'gpt-4.1';

export const selectModelStyles = {
    control: (base: OptionStyles) => ({
        ...base,
        minHeight: 27,
        height: 27,
        alignItems: 'center',
        display: 'flex',
    }),
    valueContainer: (base: OptionStyles) => ({
        ...base,
        height: '100%',
        padding: '0 6px',
    }),
    input: (base: OptionStyles) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
    menu: (base: OptionStyles) => ({
        ...base,
        minWidth: 200,
    }),
};
